import { colors, Stack, Typography } from '@ui-components/neo.tax';

import { NumberContainer } from './analysis-info.styled';

export interface AnalysisFeatureProps {
  itemNumber: number;
  title: string;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  id: string;
}

export const AnalysisFeature = ({
  children,
  itemNumber,
  subtitle,
  title,
}: AnalysisFeatureProps): React.ReactElement => (
  <Stack gap={4}>
    <NumberContainer alignItems="center" justifyContent="center" borderRadius="md" backgroundColor={colors.blue[600]}>
      <Typography color="white" fontSize="2xl" fontWeight="medium">
        {itemNumber}
      </Typography>
    </NumberContainer>
    <Stack gap={1} direction="column">
      <Typography fontWeight="medium" fontSize="lg">
        {title}
      </Typography>
      {subtitle && <Typography>{subtitle}</Typography>}
      {children}
    </Stack>
  </Stack>
);
